import { render, staticRenderFns } from "./groupvue.vue?vue&type=template&id=15d5c9a4&scoped=true&"
import script from "./groupvue.vue?vue&type=script&lang=js&"
export * from "./groupvue.vue?vue&type=script&lang=js&"
import style0 from "./groupvue.vue?vue&type=style&index=0&id=15d5c9a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5c9a4",
  null
  
)

export default component.exports